"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1525],{

/***/ 22840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZC": function() { return /* binding */ DetailsLink; },
  "PD": function() { return /* binding */ RevealLink; }
});

// UNUSED EXPORTS: renderWithSpecialCharacters

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/_virtual/_tslib.esm.js
var _tslib_esm = __webpack_require__(10395);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/DotRingSpinner/index.esm.js





const Spinner = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: (prop) => prop !== 'size' && prop !== 'color' && prop !== 'dotSize'
})(({ size, color, dotSize }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    border: `${dotSize}px dotted ${color}`,
    animation: 'rotate 1.5s infinite linear',
    '@keyframes rotate': {
        to: { transform: 'rotate(360deg)' }
    }
}));
const DotRingSpinner = (_a) => {
    var { size = 25, dotSize = 4, color = '#E6EEF6' } = _a, props = (0,_tslib_esm/* __rest */._)(_a, ["size", "dotSize", "color"]);
    return (react.createElement(Spinner, Object.assign({ size: size, color: color, dotSize: dotSize }, props)));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ./hooks/useSendAnalytic.ts + 1 modules
var useSendAnalytic = __webpack_require__(24530);
// EXTERNAL MODULE: ./utils/captcha.ts
var captcha = __webpack_require__(6806);
// EXTERNAL MODULE: ./utils/getConfigVariable.ts
var getConfigVariable = __webpack_require__(81027);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(68682);
;// CONCATENATED MODULE: ./components/RevealLink.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var DetailsLink = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "primary" && prop !== "secondary" && prop !== "tertiary";
    }
})(function(param) {
    var theme = param.theme, type = param.type, isWPA = param.isWPA;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    return _objectSpread({
        maxWidth: "100%",
        width: "100%",
        flex: 1,
        color: theme.palette.common.white,
        textDecoration: "none",
        "&:hover, &:active": isWPA ? {
            background: "linear-gradient(90deg, rgb(34, 88, 177) 0%, rgb(20, 57, 119) 100%)",
            color: theme.palette.common.white
        } : undefined
    }, !isWPA && type === "primary" ? _objectSpread({}, (ref = theme.components) === null || ref === void 0 ? void 0 : (ref1 = ref.MuiButton) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.styleOverrides) === null || ref2 === void 0 ? void 0 : ref2.root, (ref3 = theme.components) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.MuiButton) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.styleOverrides) === null || ref5 === void 0 ? void 0 : ref5.containedPrimary) : {}, !isWPA && type === "secondary" ? {
        backgroundColor: theme.palette.secondary.light
    } : {}, !isWPA && type === "tertiary" ? _objectSpread({}, (ref6 = theme.components) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.MuiButton) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.styleOverrides) === null || ref8 === void 0 ? void 0 : ref8.outlinedPrimary) : {}, {
        cursor: "pointer",
        padding: "8px 16px",
        borderRadius: "24px",
        border: isWPA && type !== "secondary" ? "none" : "1px solid ".concat(theme.palette.primary.main),
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        justifyContent: "center",
        backgroundColor: "#2258B1"
    }, !isWPA && type === "primary" ? {
        backgroundColor: "#2B59E0"
    } : {}, !isWPA && type === "secondary" ? {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main
    } : {}, isWPA && type === "secondary" ? {
        backgroundColor: "#E2EEFA",
        color: "#2258B1"
    } : {}, !isWPA && type === "tertiary" ? {
        backgroundColor: theme.palette.secondary.light
    } : {}, {
        "&:active, &:focus": isWPA ? undefined : {
            outline: "none"
        },
        p: _objectSpread({}, theme.typography[type === "secondary" ? "body2" : "body1"], {
            fontSize: "15px",
            fontWeight: 500,
            margin: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }),
        svg: {
            width: "18px",
            height: "18px",
            marginRight: "9px"
        }
    });
});
var renderWithSpecialCharacters = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", mimType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "text/html";
    try {
        if (!value) {
            return "";
        }
        var parser = new DOMParser();
        return parser.parseFromString(value, mimType).body.textContent || "";
    } catch (_err) {
        return value || "";
    }
};
var GOOGLE_CAPTCHA_KEY = (0,getConfigVariable/* default */.Z)("BOOK_ACTIONS_GOOGLE_CAPTCHA_KEY");
var googleRecaptcha = new captcha/* GoogleRecaptcha */.k(GOOGLE_CAPTCHA_KEY);
var RevealLink = function(param) {
    var children = param.children, href = param.href, revealTitle = param.revealTitle, skipReveal = param.skipReveal, newWindow = param.newWindow, requestType = param.requestType, onClickRevealHandler = param.onClickRevealHandler, onClickLinkHandler = param.onClickLinkHandler, specialistId = param.specialistId, practiceId = param.practiceId, slug = param.slug, bookingButton = param.bookingButton, icon = param.icon, active = param.active, revealLink = param.revealLink, contactValue = param.contactValue, captchaEnabled = param.captchaEnabled;
    var ref = (0,react.useState)(false), reveal = ref[0], setReveal = ref[1];
    var ref9 = (0,react.useState)(false), isLoading = ref9[0], setIsLoading = ref9[1];
    var sendAnalytic = (0,useSendAnalytic/* useSendAnalytic */.y)(slug, specialistId, practiceId);
    var theme = (0,useTheme_esm/* default */.Z)();
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var activeButtonStyle = active ? "primary" : "tertiary";
    var skipRevealButtonStyle = skipReveal ? activeButtonStyle : "secondary";
    var handleAnalyticsAndCaptcha = function(onSuccess) {
        if (captchaEnabled) {
            var sendAnalyticRequest = function(headers) {
                return sendAnalytic(requestType, contactValue, headers).then(function(success) {
                    if (success) {
                        onSuccess();
                    }
                });
            };
            googleRecaptcha.handleWithValidation(sendAnalyticRequest);
        } else {
            sendAnalytic(requestType, contactValue);
            onSuccess();
        }
    };
    var onClickReveal = function() {
        setIsLoading(true);
        handleAnalyticsAndCaptcha(function() {
            setReveal(true);
            if (onClickRevealHandler) {
                Promise.resolve(onClickRevealHandler()).finally(function() {
                    return setIsLoading(false);
                });
            } else {
                setIsLoading(false);
            }
        });
    };
    var onClickLink = function() {
        handleAnalyticsAndCaptcha(function() {
            if (onClickLinkHandler) {
                onClickLinkHandler();
            }
        });
    };
    if (!reveal && !skipReveal) {
        var type = active ? "primary" : "tertiary";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsLink, {
            /* eslint-disable-next-line no-nested-ternary */ component: isMobile ? "a" : revealLink ? "a" : "button",
            type: type,
            role: "button",
            onClick: onClickReveal,
            isWPA: isWPA,
            children: isLoading && isWPA ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DotRingSpinner, {
                size: 23
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: revealTitle
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsLink, {
        type: skipRevealButtonStyle,
        component: "a",
        href: href ? renderWithSpecialCharacters(href) : undefined,
        target: newWindow && href ? "_blank" : undefined,
        onClick: onClickLink,
        role: "link",
        isWPA: isWPA,
        children: [
            bookingButton && icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 59604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _RevealLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22840);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ContactDescription = function(_param) /*#__PURE__*/ {
    var //todo: fix lint
    // eslint-disable-next-line no-unused-vars
    description = _param.description, revealName = _param.revealName, skipReveal = _param.skipReveal, props = _objectWithoutProperties(_param, [
        "description",
        "revealName",
        "skipReveal"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RevealLink__WEBPACK_IMPORTED_MODULE_2__/* .RevealLink */ .PD, _objectSpread({}, props, {
        skipReveal: skipReveal,
        newWindow: true,
        captchaEnabled: true,
        children: revealName
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactDescription);


/***/ }),

/***/ 2496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ RevealsContainer; },
  "Z": function() { return /* binding */ SpecialistPracticeBookingCard_Layout; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./providers/AppData/Profile/index.tsx
var Profile = __webpack_require__(33228);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Avatar/Avatar.esm.js + 2 modules
var Avatar_esm = __webpack_require__(94801);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Tooltip/index.esm.js
var index_esm = __webpack_require__(63759);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Rating/index.esm.js
var Rating_index_esm = __webpack_require__(98855);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ./components/Icons/PremiumBadge.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var PremiumBadge = function(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, _objectSpread({
        width: "125",
        height: "35",
        viewBox: "0 0 125 35"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0.75 4.35449C0.75 3.24992 1.64543 2.35449 2.75 2.35449H118.997C120.645 2.35449 121.586 4.23722 120.596 5.55553L111.664 17.4487C111.13 18.1602 111.13 19.1392 111.664 19.8508L120.596 31.7439C121.586 33.0622 120.645 34.945 118.997 34.945H2.75C1.64543 34.945 0.75 34.0495 0.75 32.945V4.35449Z",
                    fill: "#FFD660"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.25 2C3.25 0.895431 4.14543 0 5.25 0H121.008C122.655 0 123.596 1.87858 122.61 3.19745L113.657 15.1741C113.126 15.8842 113.126 16.8589 113.657 17.569L122.61 29.5457C123.596 30.8645 122.655 32.7431 121.008 32.7431H5.25C4.14543 32.7431 3.25 31.8477 3.25 30.7431V2Z",
                    fill: "url(#paint0_linear_3285_1438)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip0_3285_1438)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M86.4072 13.3042L87.2726 12.7413V20.3017C87.2726 21.1352 87.935 21.8138 88.7486 21.8138H98.2482C99.0618 21.8138 99.7242 21.1352 99.7242 20.3017V12.7413L100.59 13.3042C100.67 13.3552 100.758 13.3807 100.846 13.3807C101.005 13.3807 101.16 13.3002 101.25 13.1532C101.392 12.9237 101.327 12.6217 101.103 12.4765L99.7242 11.5803V11.5665H99.7032L93.7549 7.69514C93.5979 7.59316 93.3988 7.59316 93.2419 7.69514L87.2936 11.5646H87.2726V11.5783L85.8941 12.4746C85.6701 12.6197 85.6051 12.9237 85.7467 13.1512C85.8884 13.3807 86.1851 13.4473 86.4072 13.3022V13.3042ZM93.4984 8.68947L98.767 12.1176V20.3017C98.767 20.5939 98.5353 20.8332 98.2482 20.8332H88.7467C88.4614 20.8332 88.2279 20.5959 88.2279 20.3017V12.1176L93.4984 8.68947Z",
                            fill: "#FFDB6F"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            opacity: "0.9",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M93.6927 17.6445C93.5727 17.583 93.4294 17.583 93.3094 17.6445L91.6678 18.4866C91.3657 18.6416 91.0126 18.3913 91.0703 18.0631L91.3838 16.2794C91.4067 16.1491 91.3624 16.0161 91.2654 15.9238L89.9373 14.6606C89.6929 14.4282 89.8278 14.0231 90.1655 13.9752L92.0009 13.715C92.135 13.696 92.251 13.6138 92.311 13.4952L93.1318 11.8724C93.2828 11.5738 93.7192 11.5738 93.8703 11.8724L94.6911 13.4952C94.7511 13.6138 94.867 13.696 95.0012 13.715L96.8365 13.9752C97.1743 14.0231 97.3092 14.4282 97.0647 14.6606L95.7367 15.9238C95.6396 16.0161 95.5953 16.1491 95.6182 16.2794L95.9318 18.0631C95.9895 18.3913 95.6364 18.6416 95.3343 18.4866L93.6927 17.6445Z",
                            fill: "#FFDB6F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24.9781 13.9634C24.9781 14.4227 24.8697 14.856 24.6531 15.2634C24.4364 15.6707 24.0897 16.0044 23.6131 16.2644C23.1364 16.5157 22.5254 16.6414 21.7801 16.6414H20.1421V20.3074H18.6601V11.2724H21.7801C22.4734 11.2724 23.0584 11.3937 23.5351 11.6364C24.0204 11.8704 24.3801 12.191 24.6141 12.5984C24.8567 13.0057 24.9781 13.4607 24.9781 13.9634ZM21.7801 15.4324C22.3434 15.4324 22.7637 15.3067 23.0411 15.0554C23.3184 14.7954 23.4571 14.4314 23.4571 13.9634C23.4571 12.9754 22.8981 12.4814 21.7801 12.4814H20.1421V15.4324H21.7801ZM27.8735 14.1844C28.0902 13.8204 28.3762 13.5387 28.7315 13.3394C29.0955 13.1314 29.5245 13.0274 30.0185 13.0274V14.5614H29.6415C29.0608 14.5614 28.6188 14.7087 28.3155 15.0034C28.0208 15.298 27.8735 15.8094 27.8735 16.5374V20.3074H26.3915V13.1444H27.8735V14.1844ZM37.9458 16.5504C37.9458 16.819 37.9284 17.0617 37.8938 17.2784H32.4208C32.4641 17.8504 32.6764 18.3097 33.0578 18.6564C33.4391 19.003 33.9071 19.1764 34.4618 19.1764C35.2591 19.1764 35.8224 18.8427 36.1518 18.1754H37.7508C37.5341 18.834 37.1398 19.3757 36.5678 19.8004C36.0044 20.2164 35.3024 20.4244 34.4618 20.4244C33.7771 20.4244 33.1618 20.2727 32.6158 19.9694C32.0784 19.6574 31.6538 19.224 31.3418 18.6694C31.0384 18.106 30.8868 17.456 30.8868 16.7194C30.8868 15.9827 31.0341 15.337 31.3288 14.7824C31.6321 14.219 32.0524 13.7857 32.5898 13.4824C33.1358 13.179 33.7598 13.0274 34.4618 13.0274C35.1378 13.0274 35.7401 13.1747 36.2688 13.4694C36.7974 13.764 37.2091 14.18 37.5038 14.7174C37.7984 15.246 37.9458 15.857 37.9458 16.5504ZM36.3988 16.0824C36.3901 15.5364 36.1951 15.0987 35.8138 14.7694C35.4324 14.44 34.9601 14.2754 34.3968 14.2754C33.8854 14.2754 33.4478 14.44 33.0838 14.7694C32.7198 15.09 32.5031 15.5277 32.4338 16.0824H36.3988ZM48.0752 13.0274C48.6385 13.0274 49.1412 13.1444 49.5832 13.3784C50.0339 13.6124 50.3849 13.959 50.6362 14.4184C50.8962 14.8777 51.0262 15.4324 51.0262 16.0824V20.3074H49.5572V16.3034C49.5572 15.662 49.3969 15.1724 49.0762 14.8344C48.7555 14.4877 48.3179 14.3144 47.7632 14.3144C47.2085 14.3144 46.7665 14.4877 46.4372 14.8344C46.1165 15.1724 45.9562 15.662 45.9562 16.3034V20.3074H44.4872V16.3034C44.4872 15.662 44.3269 15.1724 44.0062 14.8344C43.6855 14.4877 43.2479 14.3144 42.6932 14.3144C42.1385 14.3144 41.6965 14.4877 41.3672 14.8344C41.0465 15.1724 40.8862 15.662 40.8862 16.3034V20.3074H39.4042V13.1444H40.8862V13.9634C41.1289 13.6687 41.4365 13.439 41.8092 13.2744C42.1819 13.1097 42.5805 13.0274 43.0052 13.0274C43.5772 13.0274 44.0885 13.1487 44.5392 13.3914C44.9899 13.634 45.3365 13.985 45.5792 14.4444C45.7959 14.011 46.1339 13.6687 46.5932 13.4174C47.0525 13.1574 47.5465 13.0274 48.0752 13.0274ZM53.666 12.1954C53.3973 12.1954 53.172 12.1044 52.99 11.9224C52.808 11.7404 52.717 11.515 52.717 11.2464C52.717 10.9777 52.808 10.7524 52.99 10.5704C53.172 10.3884 53.3973 10.2974 53.666 10.2974C53.926 10.2974 54.147 10.3884 54.329 10.5704C54.511 10.7524 54.602 10.9777 54.602 11.2464C54.602 11.515 54.511 11.7404 54.329 11.9224C54.147 12.1044 53.926 12.1954 53.666 12.1954ZM54.394 13.1444V20.3074H52.912V13.1444H54.394ZM62.8267 13.1444V20.3074H61.3447V19.4624C61.1107 19.757 60.8031 19.991 60.4217 20.1644C60.0491 20.329 59.6504 20.4114 59.2257 20.4114C58.6624 20.4114 58.1554 20.2944 57.7047 20.0604C57.2627 19.8264 56.9117 19.4797 56.6517 19.0204C56.4004 18.561 56.2747 18.0064 56.2747 17.3564V13.1444H57.7437V17.1354C57.7437 17.7767 57.9041 18.2707 58.2247 18.6174C58.5454 18.9554 58.9831 19.1244 59.5377 19.1244C60.0924 19.1244 60.5301 18.9554 60.8507 18.6174C61.1801 18.2707 61.3447 17.7767 61.3447 17.1354V13.1444H62.8267ZM73.4531 13.0274C74.0165 13.0274 74.5191 13.1444 74.9611 13.3784C75.4118 13.6124 75.7628 13.959 76.0141 14.4184C76.2741 14.8777 76.4041 15.4324 76.4041 16.0824V20.3074H74.9351V16.3034C74.9351 15.662 74.7748 15.1724 74.4541 14.8344C74.1335 14.4877 73.6958 14.3144 73.1411 14.3144C72.5865 14.3144 72.1445 14.4877 71.8151 14.8344C71.4945 15.1724 71.3341 15.662 71.3341 16.3034V20.3074H69.8651V16.3034C69.8651 15.662 69.7048 15.1724 69.3841 14.8344C69.0635 14.4877 68.6258 14.3144 68.0711 14.3144C67.5165 14.3144 67.0745 14.4877 66.7451 14.8344C66.4245 15.1724 66.2641 15.662 66.2641 16.3034V20.3074H64.7821V13.1444H66.2641V13.9634C66.5068 13.6687 66.8145 13.439 67.1871 13.2744C67.5598 13.1097 67.9585 13.0274 68.3831 13.0274C68.9551 13.0274 69.4665 13.1487 69.9171 13.3914C70.3678 13.634 70.7145 13.985 70.9571 14.4444C71.1738 14.011 71.5118 13.6687 71.9711 13.4174C72.4305 13.1574 72.9245 13.0274 73.4531 13.0274Z",
                    fill: "#FFDB6F"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint0_linear_3285_1438",
                            x1: "-4",
                            y1: "3.47889",
                            x2: "127.589",
                            y2: "32.7431",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#1D3E93"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#01113D"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip0_3285_1438",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "16",
                                height: "16",
                                fill: "white",
                                transform: "translate(85.5 6.84106)"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Icons_PremiumBadge = (PremiumBadge);

// EXTERNAL MODULE: ./components/profiles/ProfileModal/NextAvailableSlotLabel/index.tsx
var NextAvailableSlotLabel = __webpack_require__(35991);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
;// CONCATENATED MODULE: ./components/profiles/ProfileModal/SpecialistPracticeBookingCard/Layout.tsx
function Layout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Layout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Layout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var RevealsContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return Layout_defineProperty({
        display: "flex",
        gap: "8px",
        width: "100%",
        marginTop: "16px",
        flexWrap: "wrap"
    }, theme.breakpoints.down("sm"), {
        "& > button, & > a": {
            flex: 1
        }
    });
});
var Root = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return Layout_defineProperty({
        padding: "16px 0",
        width: "100%",
        "&:not(:last-child)": {
            borderBottom: "1px solid ".concat(theme.palette.divider)
        },
        "&:first-of-type": {
            borderTop: "1px solid ".concat(theme.palette.divider)
        }
    }, theme.breakpoints.down("sm"), {
        flexDirection: "column"
    });
});
var StyledAvatar = (0,styled_esm/* default */.ZP)(Avatar_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        width: 82,
        height: 82,
        marginRight: "16px",
        borderRadius: "8px",
        border: "1px solid ".concat(theme.palette.grey[600])
    };
});
var PremiumTooltip = function(param) {
    var children = param.children;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
        title: translate("filter.premium.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                width: "fit-content"
            },
            children: children
        })
    });
};
var Layout = function(param1) {
    var specialistPractice = param1.specialistPractice, onlineBookingAvailable = param1.onlineBookingAvailable, firstAvailableBooking = param1.firstAvailableBooking, premium = param1.premium, showRatingSeparately = param1.showRatingSeparately, children = param1.children;
    var ref, ref1, ref2;
    var locale = (0,router.useRouter)().locale;
    var practice = (0,react.useContext)(Profile/* ProfileContext */.J).practice;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var theme = (0,useTheme_esm/* default */.Z)();
    var contactName = specialistPractice.contactName, image = specialistPractice.image, logo = specialistPractice.logo, overallExperience = specialistPractice.overallExperience, reviewsTotal = specialistPractice.reviewsTotal, address = specialistPractice.address;
    var profileAvatarAbbreviation = contactName === null || contactName === void 0 ? void 0 : contactName[0].toUpperCase();
    var RatingAndReviewSection = function(param) {
        var containerStyles = param.containerStyles;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
            container: true,
            alignItems: "center",
            columnSpacing: 1,
            sx: Layout_objectSpread({
                marginLeft: 0
            }, containerStyles),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    container: true,
                    width: "auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating_index_esm/* default */.Z, {
                        size: "small",
                        sx: {
                            fontSize: "15px"
                        },
                        value: 1,
                        max: 1,
                        readOnly: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    sx: {
                        paddingLeft: "4px !important"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_esm/* default */.Z, {
                        variant: "body2",
                        fontWeight: showRatingSeparately ? "" : "500",
                        children: [
                            overallExperience,
                            " Trust Score"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        paddingLeft: "8px",
                        paddingRight: "8px"
                    },
                    children: "\u2022"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    sx: {
                        paddingLeft: "0px !important"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_esm/* default */.Z, {
                        variant: "body2",
                        fontWeight: "400",
                        color: "text.disabled",
                        children: [
                            reviewsTotal,
                            " ",
                            translate("reviews.reviews").toLowerCase()
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        container: true,
        direction: "column",
        alignItems: "center",
        children: [
            (!!specialistPractice || !!practice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        item: true,
                        direction: "row",
                        wrap: "nowrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAvatar, {
                                    src: image || logo,
                                    children: profileAvatarAbbreviation
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                container: true,
                                item: true,
                                direction: "column",
                                rowSpacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                        item: true,
                                        mb: "4px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                            fontSize: "18px",
                                            sx: theme.custom.SpecialistPage.BookingCardLayoutName,
                                            lineHeight: "22.4px",
                                            variant: "h4",
                                            color: "text.primary",
                                            children: contactName
                                        })
                                    }),
                                    !!reviewsTotal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        gap: "4px",
                                        flexDirection: "column",
                                        children: [
                                            address && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                    variant: "body2",
                                                    color: "text.secondary",
                                                    children: "".concat(address === null || address === void 0 ? void 0 : (ref = address.street1) === null || ref === void 0 ? void 0 : ref[language], ", ").concat(address === null || address === void 0 ? void 0 : (ref1 = address.city) === null || ref1 === void 0 ? void 0 : ref1[language], " ").concat(address === null || address === void 0 ? void 0 : (ref2 = address.postcode) === null || ref2 === void 0 ? void 0 : ref2[language])
                                                })
                                            }),
                                            premium && locale === global/* TENANTS.WPA */.rk.WPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumTooltip, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PremiumBadge, {
                                                    sx: {
                                                        width: "106px",
                                                        height: "28px"
                                                    }
                                                })
                                            }),
                                            !showRatingSeparately && !onlineBookingAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingAndReviewSection, {}) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    showRatingSeparately || onlineBookingAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingAndReviewSection, {
                                containerStyles: {
                                    margin: "16px 0 8px 0"
                                }
                            }),
                            onlineBookingAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextAvailableSlotLabel/* default */.Z, {
                                withoutDateTime: !firstAvailableBooking,
                                children: firstAvailableBooking
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RevealsContainer, {
                children: children
            })
        ]
    });
};
/* harmony default export */ var SpecialistPracticeBookingCard_Layout = (Layout);


/***/ }),

/***/ 887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ EventAvailable; }
/* harmony export */ });
var EventAvailable = {};




/***/ }),

/***/ 1571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LocalPhone; }
/* harmony export */ });
var LocalPhone = {};




/***/ }),

/***/ 65658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ QuestionAnswer; }
/* harmony export */ });
var QuestionAnswer = {};




/***/ }),

/***/ 6736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CalendarOutlinedIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);


const CalendarOutlinedIcon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({ width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { x: "2.91406", y: "4.12317", width: "15.166", height: "12.8913", rx: "2", fill: "white", fillOpacity: "0.3", stroke: "white", strokeWidth: "1.2" }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2.91406 7.56091H18.0801", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M7.375 3.26355L7.375 4.98239", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13.6172 3.26355L13.6172 4.98239", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M8.125 17.0138C15.9282 17.0138 17.879 10.8208 17.879 7.72424V15.5138C17.879 16.3422 17.2074 17.0138 16.379 17.0138H8.125Z", fill: "#1A3586", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" })));




/***/ }),

/***/ 60701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmailOutlinedIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);


const EmailOutlinedIcon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { x: "1.98438", y: "4.08899", width: "16.0282", height: "12.5", rx: "2", stroke: "white", strokeWidth: "1.2" }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M8.54256 11.1462L2.89062 4.73979C2.89062 4.48958 3.09346 4.28674 3.34367 4.28674H16.771C17.0109 4.54374 17.0165 4.94091 16.7839 5.20457L11.5421 11.1461C10.7459 12.0486 9.33876 12.0486 8.54256 11.1462Z", fill: "white", fillOpacity: "0.3", stroke: "white", strokeWidth: "1.2" })));




/***/ })

}]);